module.exports = __webpack_public_path__ + "img/shadow.649b9fec.png";